import {
  defaultHistoryFields,
  isDeletedField
} from "@/components/Tables/defaultFields";
import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";
import NumericFilterModel from "@/components/Tables/Filters/models/numericFilterModel";

let pricesFields = [
  {
    key: "name",
    label: "Название абонемента",
    filter: new StringFilterModel()
  },
  {
    key: "value",
    label: "Стоимость абонемента (руб.)",
    formatter: value => Number(value),
    filter: new NumericFilterModel()
  }
];

const priceHistoryFields = [...pricesFields, ...defaultHistoryFields];

pricesFields.push(isDeletedField);

export { pricesFields, priceHistoryFields };
